// extracted by mini-css-extract-plugin
export default {"sidebar":"sidebar_sidebar__jUFq+","content":"sidebar_content__-CzN5"};